import React from 'react';
import SelectPicker, {registerLocale} from "react-datepicker"
import FieldError from './FieldError'
import { withFormsy } from 'formsy-react';
import {DateHelper} from "../../util/date-helper"
import ja from 'date-fns/locale/ja';
import { trackingEvent } from "../pages/layouts/GoogleAnalytics.js"
registerLocale('ja', ja);

class DatePicker extends React.Component {
  _calendar = React.createRef();
  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
    this.state = {date: this.props.startDate ? new Date(this.props.startDate) : new Date()}
  }

  changeValue(date) {
    this.trackingOnChange()
    this.props.setValue(date && DateHelper.output(date, 'YYYY-MM-DD'));
    this.setState({date: date})
  }

  componentWillMount() {
    this.props.setValue(DateHelper.output(this.state.date, 'YYYY-MM-DD'))
  }

  trackingOnChange() {
    if (this.props.isCsv && this.props.name === "from_date") {
      trackingEvent("CSV", "対象期間を選択(開始)")
    } else if (this.props.isCsv && this.props.name === "to_date") {
      trackingEvent("CSV", "対象期間を選択(終了)")
    }
  }

  render() {
    // An error message is returned only if the component is invalid
    const errorMessage = this.props.getErrorMessage();

    return (
      <div className={`${this.props.className}`}>
        <SelectPicker
          selected={this.state.date}
          onChange={this.changeValue}
          locale={this.props.locale || "ja"}
          dateFormat={this.props.dateFormat || "Pp"}
          className={`${this.props.classDatePicker} ${errorMessage ? "has-error" : ""}`}
          ref={(c) => this._calendar = c}
        />
        <i className="far fa-calendar-alt mfc-icon-calendar" onClick={() => this._calendar.setOpen(true)}></i>
        { errorMessage && <FieldError message={errorMessage} /> }
      </div>
    );
  }
}

export default withFormsy(DatePicker);
